import React, { useState,useEffect } from 'react';
import { Col, Row, Button } from 'react-bootstrap';
import ReactApexChart from "react-apexcharts";

import Icon from '@mdi/react';
import { mdiDownload } from '@mdi/js';
import {getFromAPI,formatDate,API_BASE_URL} from '../../Utils/utils';
import {toast} from 'react-toastify';
export default function SalaryStructure() {
    const isStaffId = Number(localStorage.getItem('loggedInStaffId'));
    const[payrollData,setPayRollData] = useState([]);
    const fetchPayrollData = async () => {
        try {
            const response = await getFromAPI(`FtsPayrollDetails/?staffId=${isStaffId}`);
            
            if (response && response.length > 0) {
                setPayRollData(response[0]);
            } else {
                setPayRollData([]); // Handle case where no data is returned
            }
        } catch (error) {
            console.error("Error fetching payroll data:", error);
            setPayRollData([]);
        }
    };

    const downloadPayslip = async (staffId) => {
        try {
           const url = `${API_BASE_URL}generate_payslip/?staff_id=${staffId}`;
           window.open(url, '_blank'); // Open in a new tab only if valid
          
        } catch (error) {
            console.error('Error opening payslip:', error);
            toast.error('Failed to download payslip. Please try again.');
        }
    };
    
    // Call function inside useEffect to fetch data when isStaffId changes
    useEffect(() => {
        if (isStaffId) {
            fetchPayrollData();
        }
    }, [isStaffId]);
    
 const [state, setState] = useState({
    series: [0, 0], // Default values
    options: {
        chart: {
            type: "donut",
            width: 350,
        },
        labels: ["Salary", "Gratuity"],
        legend: {
            show: false,
        },
        dataLabels: {
            enabled: false, // Disables default data labels
        },
        plotOptions: {
            pie: {
                donut: {
                    labels: {
                        show: true,
                        total: {
                            show: true,
                            label: "Salary",
                        },
                    },
                },
            },
        },
        colors: ["#5570F7", "#dc3545"],
    },
});

// Check if there is no salary structure data
const hasSalaryData = () => {
    return (
        payrollData && 
        (
            Number(payrollData.basic_salary || 0) > 0 ||
            Number(payrollData.hra || 0) > 0 
        )
    );
};

// Update the chart when payrollData changes
useEffect(() => {
    if (payrollData) {
        setState((prevState) => ({
            ...prevState,
            series: [
                Number(payrollData.basic_salary || 0) + Number(payrollData.hra || 0),
                Number(payrollData.gratuity || 0) + Number(payrollData.employer_vpf||0)+Number(payrollData.employer_esi||0),
            ],
        }));
    }
}, [payrollData]);

    return (
        <>
            <Row className='align-items-center'>
                <Col lg={4}>
                    <div>
                        <ReactApexChart options={state.options} series={state.series} type="donut" height={250} />
                    </div>
                </Col>
                <Col lg={8}>
                    <div className='mt-4 mt-lg-0'>
                        <div className="d-sm-flex text-center text-sm-start justify-content-between">
                            <div>
                            <h4 className=''>
                                Monthly CTC:₹{Number(payrollData.ctc || 0)}
                            </h4>
                            <p className='fs-16'>
                                Yearly CTC: ₹ { 
                                    (Number(payrollData.ctc || 0)*12)
                                }
                            </p>
                            </div>
                            <div>
                                <Button variant="success" onClick={() => downloadPayslip(isStaffId)} disabled={!hasSalaryData()}>Download Slip <Icon path={mdiDownload} className='icon-size-16 ms-1' /></Button>
                            </div>
                        </div>
                        <Row className='mt-4'>
                            <Col sm={4} xl={3} className='mb-4 mb-sm-0'>
                                <div className='p-4 text-center border bg-soft-success border-soft-success rounded-2 h-100'>
                                    <h5 className='fw-normal'>Earnings</h5>
                                    <p className='text-muted mb-0'>₹{Number(payrollData.basic_salary || 0) + Number(payrollData.hra || 0)+Number(payrollData.conveynace_allowance||0)+Number(payrollData.telephone_allowance||0)}</p>
                                </div>
                            </Col>
                            <Col sm={4} xl={3} className='mb-4 mb-sm-0'>
                                <div className='p-4 text-center border bg-soft-info border-soft-info rounded-2 h-100'>
                                    <h5 className='fw-normal'>Reimbursement</h5>
                                    <p className='text-muted mb-0'>₹{Number(payrollData.reimbursements|| 0)}</p>
                                </div>
                            </Col>
                            <Col sm={4} xl={3}>
                                <div className='p-4 text-center border bg-soft-warning border-soft-warning rounded-2 h-100'>
                                    <h5 className='fw-normal'>Benefits</h5>
                                    <p className='text-muted mb-0'>₹{Number(payrollData.gratuity || 0) + Number(payrollData.employer_esi || 0) + Number(payrollData.employer_vpf || 0)}</p>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>

            <Row>
                <Col md={6}>
                    <div className='p-4 border rounded-2 mt-5'>
                        <h5 className='mb-4'>Other Benefits</h5>
                        <h5 className='fs-17 mb-4'>Gratuity Deducation</h5>
                        <div className='d-flex justify-content-between border-bottom gap-3 pb-4 mb-4'>
                            <h6 className='fw-normal mb-0'>Employer Contribution</h6>
                            <h6 className=' mb-0'>4.81% of Basic</h6>
                        </div>
                        <h5 className='fs-17 mb-4'>Employer VPF Deducation</h5>
                        <div className='d-flex justify-content-between border-bottom gap-3 pb-4 mb-4'>
                            <h6 className='fw-normal mb-0'>Employer Contribution</h6>
                            <h6 className=' mb-0'>13% of Basic</h6>
                        </div>
                        {/* <div className='d-flex justify-content-between gap-3'>
                            <h6 className='fw-normal mb-0'>Your Contribution</h6>
                            <h6 className='mb-0'>0.00% of Basic</h6>
                        </div> */}
                    </div>
                </Col>
                <Col md={6}>
                    <div className='p-4 border rounded-2 mt-5'>
                        <h5 className='mb-4'>Earnings</h5>
                        <div className='d-flex justify-content-between border-bottom gap-3 pb-4 mb-4'>
                            <h6 className='fw-normal mb-0'>Basic</h6>
                            <h6 className='fw-normal text-muted mb-0'>₹{payrollData.basic_salary || 0}</h6>
                        </div>
                        <div className='d-flex justify-content-between border-bottom gap-3 pb-4'>
                            <h6 className='fw-normal mb-0'>House Rent Allowance</h6>
                            <h6 className='fw-normal text-muted mb-0'>₹{payrollData.hra || 0}</h6>
                        </div>
                        <div className='d-flex justify-content-between border-bottom gap-3 pb-4'>
                            <h6 className='fw-normal mb-0'>Conveyance Allowance</h6>
                            <h6 className='fw-normal text-muted mb-0'>₹{payrollData.conveynace_allowance || 0}</h6>
                        </div>
                        <div className='d-flex justify-content-between border-bottom gap-3 pb-4'>
                            <h6 className='fw-normal mb-0'>Telephone Allowance</h6>
                            <h6 className='fw-normal text-muted mb-0'>₹{payrollData.telephone_allowance || 0}</h6>
                        </div>

                        <h5 className='mt-5 mb-4'>Benefits</h5>
                        <div className='d-flex justify-content-between border-bottom gap-3 pb-4 mb-4'>
                            <h6 className='fw-normal mb-0'>Gratuity Deduction - Employer Contribution </h6>
                            <h6 className='fw-normal text-muted mb-0'>₹{payrollData.gratuity || 0}</h6>
                        </div>
                        <div className='d-flex justify-content-between border-bottom gap-3 pb-4 mb-4'>
                            <h6 className='fw-normal mb-0'>Employer Contribution(13% of Restricted PF wages) </h6>
                            <h6 className='fw-normal text-muted mb-0'>₹{payrollData.employer_vpf || 0}</h6>
                        </div>
                        <div className='d-flex justify-content-between border-bottom gap-3 pb-4 mb-4'>
                            <h6 className='fw-normal mb-0'>Employer ESI</h6>
                            <h6 className='fw-normal text-muted mb-0'>₹{payrollData.employer_esi || 0}</h6>
                        </div>
                        <div className='d-flex justify-content-between gap-5'>
                            <h6 className='fw-normal text-end w-100 mb-0'>Monthly CTC</h6>
                            <h6 className='fw-normal text-muted mb-0'>₹{Number(payrollData.ctc || 0)}</h6>
                        </div>
                    </div>
                </Col>
            </Row>
        </>
    )
}
